import React, {memo} from "react";
import { Container, Modal, CloseButton } from "react-bootstrap";
import "./GenericModal.css";

function GenericModal({ className, key, showModal, handleShowModal, ChildComponent, fullscreen ,variant}) {
  const isFullscreen = fullscreen !== false;

  return (
    <Modal
      show={showModal}
      centered={!isFullscreen}
      fullscreen={isFullscreen}
      onHide={() => handleShowModal(false)}
      className={className?className:"genericModal"}
      key={key}
      id="genericModal"
      backdrop="static"
    >
      <Modal.Body>
        <Container fluid={true}>
        {ChildComponent}
        </Container>
        <CloseButton aria-label="Hide" variant={variant?variant:''} onClick={() => handleShowModal(false)}/>
      </Modal.Body>
    </Modal>
  );
}

export default memo(GenericModal);
